document.addEventListener('DOMContentLoaded', () => {
    const dialog = document.getElementById('info-modal');
    if (!dialog) return;

    const contentEl = dialog.querySelector('.info-modal__content');
    const closeBtn = dialog.querySelector('.info-modal__close');

    // Open modal (event delegation)
    document.addEventListener('click', (e) => {
        const trigger = e.target.closest('.info-modal-trigger');
        if (!trigger) return;

        e.stopPropagation();

        const content = trigger.dataset.infoContent || '';

        contentEl.innerHTML = content;
        dialog.showModal();
        document.body.classList.add('overflow-hidden');
    });

    // Close modal
    function closeModal() {
        dialog.close();
        contentEl.innerHTML = '';
        document.body.classList.remove('overflow-hidden');
    }
    closeBtn.addEventListener('click', closeModal);

    // click outside content
    dialog.addEventListener('click', (e) => {
        if (e.target === dialog) {
            closeModal();
        }
    });

    // ESC key support
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && dialog.open) {
            closeModal();
        }
    });
});
